import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (typeof window !== "undefined" && dsn && dsn !== "your-sentry-dsn-here") {
  Sentry.init({
    dsn,
    environment: import.meta.env.DEV ? "development" : "production",
  });
}
